<div class="event-list">
  <ng-container *ngFor="let event_obj of events; let i = index">
    <div class="event-group" *ngIf='event_obj.date_count < 8'>
      <!-- Date Header -->
      <div *ngIf="lastDatePosition != event_obj.date_position || i == 0" class="date-header" [ngClass]="{'today-header': event_obj.isToday}">
        <span class="date-text">{{ setLastDatePosition(event_obj.date_position) }}</span>
        <span *ngIf="event_obj.isToday" class="today-badge">Today</span>
        <button class="btn btn-link btn-sm add-btn" type="button" (click)="openNewEvent(event_obj.date_position)">
          <i class="fas fa-plus-circle"></i>
        </button>
      </div>
      <!-- Event Item -->
      <div class="event-item" [ngClass]="{'event-past': event_obj.isPast, 'event-today': event_obj.isToday}" [ngStyle]="{ 'border-left-color': event_obj.color }">
        <div class="event-time">
          <a (click)="event_obj.expanded = !event_obj.expanded" href="javascript: void(0)" title="Expand/collapse">
            <i class="fas" [ngClass]="{ 'fa-chevron-right': !event_obj.expanded, 'fa-chevron-down': event_obj.expanded }"></i>
          </a>
          <span class="time-text">{{ event_obj.event_title }}</span>
        </div>
        <div class="event-details">
          <span class="event-type" [style.color]="event_obj.color">{{ event_obj.display_name }}</span>
          <span class="event-type-name">{{ event_obj.event_type_name }}</span>
          <span *ngIf="event_obj.title" class="event-title-text">{{ event_obj.title }}</span>
          <span *ngIf="event_obj.recurring" class="recurring-badge" title="Recurring event"><i class="fas fa-redo"></i></span>
          <a [routerLink]="'/events/' + event_obj.id" class="event-link" title="View event"><i class="fas fa-external-link-alt"></i></a>
        </div>
        <div class="event-matter" *ngIf="event_obj.matter_id">
          <a [routerLink]="'/matters/' + event_obj.matter_id">{{ event_obj.matter_name }}</a>
        </div>
        <app-event [event_id]="event_obj.id" *ngIf="event_obj.expanded"></app-event>
      </div>
    </div>
  </ng-container>
  <div *ngIf="events.length === 0" class="empty-events">
    <i class="fas fa-calendar-check"></i>
    <p>No upcoming events</p>
  </div>
</div>